import BipoleLeadTable from "./BipoleLeadTable";

export default BipoleLeadTable